import { configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import multiStepFormReducer from './multiStepFormSlice';
import accordionReducer from './accordionSlice';
import eligibilityReducer from './eligibilityReducer';
import schemaReducer from './schemaSlice';
import locationReducer from './locationSlice';
import { useDispatch } from 'react-redux';

const rootReducer = combineReducers({
  multiStepForm: multiStepFormReducer,
  accordion: accordionReducer,
  eligibility: eligibilityReducer,
  schema: schemaReducer,
  location: locationReducer,
});

const persistConfig = {
  key: 'root_v1.1',
  storage,
  whitelist: [
    'auth',
    'multiStepForm',
    'accordion',
    'eligibility',
    'location',
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
